var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card task-lane-item"},[_c('div',{staticClass:"card-block"},[_c('h5',{staticClass:"card-title"},[_vm._t("card",function(){return [_c('div',[_vm._v("ID: "+_vm._s(_vm.item.id))]),_c('div',[_vm._v("SortField: "+_vm._s(_vm.item.sortField))])]},{"item":_vm.item})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }